import { Typography } from 'antd';
import './home.css'

const ItemView = (text, time, src, index) => {
    return (
        <div className='news-container-item' style={{
            backgroundImage: src
            // background: index % 2 == 0 ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)':'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
        }}>
            <Typography.Title type="secondary" level={3} style={{ whiteSpace: 'wrap', color:'white' }}>
                {text}
            </Typography.Title>
            <Typography.Title type="secondary" level={5} style={{ whiteSpace: 'wrap', color:'white' }}>
                {time}
            </Typography.Title>
        </div>
    )
}

const news = [
    {
        text: 'NEW STARTUP CHANGING THE GAME', time: 'March 1, 2025', src:'url(/images/news_1.jpeg)'
    },
    {
        text: 'OFFSITE TAKEAWAYS: DOING IT THE YUUN HOME WAY', time: 'March 1, 2025', src:'url(/images/news_2.jpeg)'
    },
    {
        text: 'OFFSITE TAKEAWAYS: DOING IT THE YUUN HOME WAY', time: 'March 1, 2025', src:'url(/images/news_3.jpeg)'
    }
]
const NewsView = () => {
    return (
        <div className='news-container-row'>
            {
                news.map((item, index) => {
                    const { time, text,src } = item
                    return ItemView(text, time, src, index)
                })
            }
        </div>
    );
};
export default NewsView;